import type { ReactNode } from "react";
import { formatDA, formatPercent } from "@ect/core";
import { Icon } from "@ect/ui";

export const money = (v: unknown) => (v == null || v === "" ? "–" : formatDA(Number(v)));
export const pct = (v: unknown) => (v == null ? "–" : formatPercent(Number(v) / 100));
export const dmy = (iso: string | null | undefined) => (iso ? new Date(iso).toLocaleDateString("fr-DZ") : "–");

export function PageHeader({ title, sub, actions, back }: { title: ReactNode; sub?: ReactNode; actions?: ReactNode; back?: { label: string; onClick: () => void } }) {
  return (
    <div className="mb-5 grid gap-3 last:mb-0">
      {back && <button type="button" onClick={back.onClick} className="flex w-fit items-center gap-2 text-sm text-ink-2 hover:text-navy"><Icon name="arrow" size={16} className="rotate-180 rtl:rotate-0" />{back.label}</button>}
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0"><h1 className="font-display text-2xl font-extrabold tracking-tight text-navy lg:text-[28px]">{title}</h1>{sub && <div className="mt-1.5 text-sm leading-relaxed text-ink-2">{sub}</div>}</div>
        {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
      </div>
    </div>
  );
}
export function Tabs<T extends string>({ tabs, value, onChange }: { tabs: { key: T; label: string; badge?: number }[]; value: T; onChange: (t: T) => void }) {
  return (
    <div role="tablist" className="mb-5 flex w-fit max-w-full flex-wrap gap-1 rounded-xl border border-line bg-surface p-1">
      {tabs.map((t) => (
        <button key={t.key} role="tab" aria-selected={value === t.key} type="button" onClick={() => onChange(t.key)} className={`rounded-lg px-3 py-2 text-sm font-medium transition-colors ${value === t.key ? "bg-tint text-navy" : "text-ink-2 hover:bg-ground hover:text-navy"}`}>
          {t.label}{!!t.badge && <span className="ms-1.5 rounded-full bg-tint px-1.5 text-[11px] font-bold text-ink-2">{t.badge}</span>}
        </button>
      ))}
    </div>
  );
}
export function Section({ title, children, actions }: { title: string; children: ReactNode; actions?: ReactNode }) {
  return (
    <section className="grid gap-2">
      <div className="mb-1 flex flex-wrap items-center justify-between gap-2"><h2 className="font-display text-base font-bold text-ink">{title}</h2>{actions}</div>
      {children}
    </section>
  );
}
